export default "__VITE_ASSET__DBLe41Bh__"